import { FamilySubscriptionV2 } from '../../model/v2/EntitiesV2';
import dateService from '../../services/DateService';
import apiAxiosV2 from './CustomAxiosV2';

class FamilySubscriptionApiV2 {
    listAll = async (): Promise<FamilySubscriptionV2[]> => {
        const response = await apiAxiosV2.get<FamilySubscriptionV2[]>(`/family-subscriptions`);
        response.data.forEach(this.loadDates);

        return response.data;
    };

    get = async (id: number): Promise<FamilySubscriptionV2> => {
        const response = await apiAxiosV2.get<FamilySubscriptionV2>(` /family-subscriptions/${id}`);
        this.loadDates(response.data);

        return response.data;
    };

    create = async (familySubscription: FamilySubscriptionV2): Promise<FamilySubscriptionV2> => {
        const response = await apiAxiosV2.post<FamilySubscriptionV2>('/family-subscriptions', familySubscription);
        this.loadDates(response.data);

        return response.data;
    };

    update = async (familySubscription: FamilySubscriptionV2): Promise<FamilySubscriptionV2> => {
        const response = await apiAxiosV2.put<FamilySubscriptionV2>(
            `/family-subscriptions/${familySubscription.id}`,
            familySubscription,
        );
        this.loadDates(response.data);

        return response.data;
    };

    /**
     * Loads the dates of a family subscription.
     * @param trap - the family subscription
     */
    private loadDates(familySubscription: FamilySubscriptionV2) {
        familySubscription.subscriptionPaid = dateService.transformDate(familySubscription.subscriptionPaid);
        familySubscription.subscriptionExpired = dateService.transformDate(familySubscription.subscriptionExpired);
    }
}

const familySubscriptionApiV2: FamilySubscriptionApiV2 = new FamilySubscriptionApiV2();
export default familySubscriptionApiV2;
